import { INavBarProps } from "./NavBar.types";
import NavBarView from "./NavBar.view";
import React from "react";

const NavBarContainer: React.FC<INavBarProps> = ({
  isLoggedIn,
  onClickLogOut,
  ...buttonGroupProps
}) => (
  <NavBarView
    {...buttonGroupProps}
    isLoggedIn={isLoggedIn}
    onClickLogOut={onClickLogOut}
  />
);

export default NavBarContainer;
